import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useState } from "react";
import PipelineModal from "../PipelineModal";
import { FiCalendar } from "react-icons/fi";

const DealsModal = ({ show, handleClose }) => {
  const [showPipeline, setShowPipeline] = useState(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="deals-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Deals</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Deal Name */}
            <Form.Group className="mb-3">
              <Form.Label>Deal Name *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Form.Group>

            {/* Pipeline + Status */}
            <Row>
              <Col md={6}>
                <div className="d-flex justify-content-between">
                  <Form.Label>Pipeline *</Form.Label>
                  <span
                    className="add-new"
                    onClick={() => {
                      setShowPipeline(true);
                      handleClose();
                    }}
                  >
                    + Add New
                  </span>
                </div>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Status *</Form.Label>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Deal Value + Currency */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Deal Value *</Form.Label>
                <Form.Control />
              </Col>

              <Col md={6}>
                <Form.Label>Currency *</Form.Label>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Period */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Period *</Form.Label>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Period Value *</Form.Label>
                <Form.Control />
              </Col>
            </Row>

            {/* Contact */}
            <Form.Group className="mt-3">
              <Form.Label>Contact *</Form.Label>
              <Form.Control placeholder="Add contact" />
            </Form.Group>

            {/* Project */}
            <Form.Group className="mt-3">
              <Form.Label>Project *</Form.Label>
              <Form.Control placeholder="Add project" />
            </Form.Group>

            {/* Dates */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Due Date *</Form.Label>
                <div className="date-box">
                  <Form.Control placeholder="dd/mm/yyyy" />
                  <FiCalendar />
                </div>
              </Col>

              <Col md={6}>
                <Form.Label>Expected Closing Date *</Form.Label>
                <div className="date-box">
                  <Form.Control placeholder="dd/mm/yyyy" />
                  <FiCalendar />
                </div>
              </Col>
            </Row>

            {/* Assignee */}
            <Form.Group className="mt-3">
              <Form.Label>Assignee *</Form.Label>
              <Form.Control placeholder="Add assignee" />
            </Form.Group>

            {/* Tags + Followup */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Tags *</Form.Label>
                <Form.Control placeholder="Add tags" />
              </Col>

              <Col md={6}>
                <Form.Label>Followup Date *</Form.Label>
                <div className="date-box">
                  <Form.Control placeholder="dd/mm/yyyy" />
                  <FiCalendar />
                </div>
              </Col>
            </Row>

            {/* Source + Priority */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Source *</Form.Label>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Priority *</Form.Label>
                <Form.Select className="custom-select">
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Description */}
            <Form.Group className="mt-3">
              <Form.Label>Description *</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>

            {/* Footer */}
            <div className="footer-actions">
              <Button variant="light" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="btn-orange">Add Deal</Button>
            </div>
          </Form>
        </Modal.Body>
        <style>
          {`
            .deals-modal .modal-content {
  border-radius: 10px;
  padding: 10px;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
}

.custom-select:focus,
.form-control:focus {
  border-color: #ff6b00 !important;
  box-shadow: 0 0 0 0.1rem rgba(255, 107, 0, 0.25) !important;
}

/* Orange selected option */
select option:checked {
  background-color: #ff6b00;
  color: #fff;
}

/* Add new link */
.add-new {
  font-size: 13px;
  color: #ff6b00;
  cursor: pointer;
}

/* Footer buttons */
.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-orange {
  background-color: #ff6b00;
  border: none;
  color: white;
}

.btn-orange:hover {
  background-color: #e65c00;
}

/* Date box */
.date-box {
  position: relative;
}

.date-box svg {
  position: absolute;
  right: 10px;
  top: 10px;
  color: gray;
}

/* Responsive */
@media (max-width: 768px) {
  .footer-actions {
    flex-direction: column;
  }

  .btn,
  .form-control,
  .form-select {
    width: 100%;
  }
}`}
        </style>
      </Modal>

      {/* Pipeline Modal */}
      <PipelineModal
        show={showPipeline}
        handleClose={() => setShowPipeline(false)}
      />
    </>
  );
};

export default DealsModal;
